import React, { useState, useContext, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

import { Context } from '@store/store';
import { getPageToBookmark } from '@utils/getPageToBookmark';

import AddBookmarkButton from './add-bookmark-button';
import RemoveBookmarkButton from './remove-bookmark-button';

import { GET_ALL_BOOKMARKS } from '@graphql/bookmarks';

const ToggleBookmarkButton = ({ isMobile }) => {
  const [state] = useContext(Context);
  const [isPageBookmarked, setIsPageBookmarked] = useState(false);
  const client = useApolloClient();

  const data = client.readQuery({
    query: GET_ALL_BOOKMARKS,
    variables: { id: state.bookId },
  });

  useEffect(() => {
    if (data) {
      const bookmarks = data?.book?.bookmarks.map(b => b.page);
      setIsPageBookmarked(
        state.isSinglePageMode
          ? bookmarks.includes(state.currentPage)
          : [state.currentPage - 1, state.currentPage].some(el => bookmarks.includes(el)),
      );
    }
  }, [state.currentPage, state.isSinglePageMode, data]);

  return isPageBookmarked ? (
    <RemoveBookmarkButton isMobile={isMobile} />
  ) : (
    <AddBookmarkButton isMobile={isMobile} />
  );
};

export default ToggleBookmarkButton;
